import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=52aa5d60&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=52aa5d60&prod&lang=css"
import style1 from "./Dialog.vue?vue&type=style&index=1&id=52aa5d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa5d60",
  null
  
)

export default component.exports